"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBrand = undefined;

var _queryString = require("query-string");

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSubdomain = function getSubdomain() {

  if (typeof window === "undefined" || window.location.href.indexOf("buoyhealth.com") === -1) {
    return undefined;
  }

  var subdomain = /:\/\/([^./]+)/.exec(window.location.href);
  if (subdomain) {
    subdomain = subdomain[1];
    // We don't really need to include this anymore, but we'll avoid a lot of
    // unnecessary calls to the backend resulting in 404s if we keep these sanity
    // checks for known subdomain lookalikes that aren't supported brands.
    if (!subdomain || subdomain === "www" || subdomain.startsWith("research") || subdomain.startsWith("sandbox") || subdomain.startsWith("staging")) {
      return undefined;
    }
  }
  return subdomain;
};

var getBrand = exports.getBrand = function getBrand() {
  var prod = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;


  if (typeof window === "undefined") {
    return undefined;
  }

  var query = _queryString2.default.parse(window.location.search).brand;
  var subdomain = getSubdomain();

  // In production, subdomain trumps the query string
  // In other environments, query string trumps subdomain for testing purposes
  var brand = void 0;
  if (prod) {
    brand = subdomain ? subdomain : query;
  } else {
    brand = query ? query : subdomain;
  }

  return brand;
};


//////////////////
// WEBPACK FOOTER
// ./~/buoy-bottom-banner/dist/utils/brands.js
// module id = 392
// module chunks = 35783957827783